<template>
  <div>
    <template v-if="!loading">
      <template v-if="hasImage">
        <v-row no-gutters class="image" @mouseover="isHover = true" @mouseout="isHover = false">
          <v-col>
            <v-row no-gutters>
              <v-col>
                <v-tooltip color="font" bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-show="isHover"
                      size="19px"
                      color="#888"
                      class="icon"
                      @click="isNewFile && options.urlFile.includes('blob') ? clearFile() : openDialog()"
                      v-on="on"
                    >
                      {{ isNewFile && options.urlFile.includes('blob') ? 'mdi-restore' : 'mdi-close' }}
                    </v-icon>
                  </template>
                  {{
                    isNewFile && options.urlFile.includes('blob')
                      ? $i18n.t('admin.return')
                      : $i18n.t('admin.deleteFile')
                  }}
                </v-tooltip>
                <v-row no-gutters>
                  <v-col class="pa-6">
                    <img
                      ref="logo"
                      :src="isNewFile ? options.urlFile : options.urlGet"
                      contain
                      @error="onError"
                      @load="onLoad"
                      :style="{ 'max-height': computedHeight, 'max-width': computedWidth }"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
      <v-row>
        <v-col class="d-flex justify-center fileInputImage">
          <file-input
            ref="file"
            :options="options"
            @fileAdded="onFileAdded"
            @error="onUploadError"
            :button-translation-path="isFile ? 'admin.changeFile' : 'admin.selectFile'"
          />
        </v-col>
      </v-row>
    </template>
    <main-loader v-else />
    <main-dialog
      v-if="isDalogLoaded"
      :is-visible.sync="isDialogOpen"
      :title="$i18n.t('dialog.deleteFile')"
      :body="$i18n.t('dialog.confirmFileDelete')"
      agree-text="dialog.agreeDelete"
      @agree="deleteFile"
    />
  </div>
</template>

<script>
import { call } from 'vuex-pathify';

import FileInput from '@/components/FileInput';
import MainLoader from '@/components/MainLoader';

export default {
  name: 'FileInputImage',
  components: {
    FileInput,
    MainLoader,
    MainDialog: () => import('@/components/MainDialog'),
  },

  props: {
    options: {
      type: Object,
      required: true,
    },
    maxHeight: {
      type: Number,
      default: 72,
    },
    maxWidth: {
      type: Number,
      default: undefined,
    },
    type: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: false,
    },
  },
  data: () => ({
    isDialogOpen: false,
    isDalogLoaded: false,
    isHover: false,
    isFile: false,
    isNewFile: false,
    hasImage: false,
    loading: false,
  }),
  created() {
    this.onInit();
  },
  computed: {
    computedHeight() {
      return `${this.maxHeight}px`;
    },
    computedWidth() {
      return this.maxWidth ? `${this.maxWidth}px` : '100%';
    },
  },
  methods: {
    checkHasImage: call('admin/checkHasImage'),
    checkHasFavicon: call('admin/checkHasFavicon'),
    checkCustomLogo: call('admin/checkCustomLogo'),
    deleteFileAction: call('admin/deleteLogo'),
    deleteFaviconAction: call('admin/deleteFavicon'),
    deleteCustomLogoAction: call('admin/deleteCustomLogo'),
    onLoad() {
      this.$emit('input', true);
    },
    onError() {
      this.$emit('input', false);
    },
    onUploadError() {
      this.$refs.file.$refs.dropzone.removeAllFiles();
    },
    onFileAdded() {
      this.isFile = true;
      this.isNewFile = true;
      this.hasImage = true;
    },
    openDialog() {
      this.isDalogLoaded = true;
      this.isDialogOpen = true;
    },
    async clearFile() {
      if (this.type === 'favicon') {
        const r = await this.checkHasFavicon();
        this.hasImage = r;
      } else if (this.type === 'customLogo') {
        const r = await this.checkCustomLogo(this.name);
        this.hasImage = r;
      } else {
        const r = await this.checkHasImage(this.type);
        this.hasImage = r;
      }
      this.isFile = false;
      this.isNewFile = false;
    },
    async deleteFile() {
      this.isDialogOpen = false;
      if (this.type === 'favicon') {
        await this.deleteFaviconAction();
      } else if (this.type === 'customLogo') {
        await this.deleteCustomLogoAction(this.name);
      } else {
        await this.deleteFileAction(this.type);
      }
      if (this.type === 'logo') {
        this.$root.$emit('refreshLogo');
      }
      this.hasImage = false;
      this.isFile = false;
    },
    async onInit() {
      this.loading = true;
      if (this.type === 'favicon') {
        const r = await this.checkHasFavicon();
        this.hasImage = r;
        this.isFile = r;
      } else if (this.type === 'customLogo') {
        const r = await this.checkCustomLogo(this.name);
        this.hasImage = r;
        this.isFile = r;
      } else {
        const r = await this.checkHasImage(this.type);
        this.hasImage = r;
        this.isFile = r;
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.image {
  border: 1px dashed rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  position: relative;
  .icon {
    display: none;
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
  }
  &:hover {
    .icon {
      display: block;
    }
  }
}
.fileInputImage {
  .v-btn.v-size--default {
    margin-right: 0 !important;
  }
}
</style>
